export const PRIOR_AUTH_REQUIREMENTS = {
    NO_REQUIREMENTS: 'No Requirement',
    PAYER_NOTIFICATION: 'Payer Notification (new billing event)',
    INITIAL_SERVICE_AUTHORIZATION: 'Initial Service Authorization',
    COC_EXTENSION: 'Continuation of Care: Extension',
    EXCEEDING_COST_THRESHOLD: 'Cost Threshold Exceeding $750 pppm',
    COST_THRESHOLD_500_749: 'Cost Threshold: $500 - $749 pppm',
    COST_THRESHOLD_250_499: 'Cost Threshold: $250 - $499 pppm',
    HIGH_COST_SERVICE_OR_MEDICATION: 'High Cost Service or Medication',
};
